import React from 'react';
import { Card, CardContent, CircularProgress, Divider, Grid, IconButton, Skeleton, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import CustomTextInput from '../CustomTextInput';
import { useSelector } from 'react-redux';
import FeatureNotSupportedDialog from '../../resources/common/FeatureNotSupportedDialog';

export default function PeppolDetails({
  control,
  errors,
  getValues,
  setParticipantId,
  handleFetchParticipants,
  loading,
  readOnly,
  loadingParticipant,
  isPeppolEmpty,
  peppolParticipant,
  peppolParticipantDescription,
}) {
  const subscription = useSelector((state) => state.org.org.subscription);

  return (
    <>
      <Typography variant="h6" sx={{ mb: '1.5rem', pt: '1rem' }}>
        Peppol Details
        <Divider />
      </Typography>

      {subscription?.features?.enable_peppol ? (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <CustomTextInput
              name="participant_id"
              control={control}
              errors={errors}
              label="Participant ID"
              onChange={() => setParticipantId(getValues('participant_id'))}
              readOnly={readOnly}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <IconButton onClick={handleFetchParticipants} color="success" disabled={loading || readOnly}>
              {loading ? <CircularProgress size={24} color="inherit" /> : <Refresh />}
            </IconButton>
          </Grid>
        </Grid>
      ) : (
        <FeatureNotSupportedDialog title="Peppol Participant ID" description={peppolParticipantDescription} />
      )}

      {loadingParticipant ? (
        <Card sx={{ mt: 4, p: 2 }}>
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="text" width="60%" height={25} />
          <Skeleton variant="rectangular" width="100%" height={50} sx={{ mt: 2 }} />
        </Card>
      ) : (
        !isPeppolEmpty && (
          <Card sx={{ mt: 4 }}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Scheme:
                      </Typography>
                      <Typography>{peppolParticipant.scheme}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Identifier Code:
                      </Typography>
                      <Typography>{peppolParticipant.identifier_code}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Special Identifier:
                      </Typography>
                      <Typography>{peppolParticipant.special_identifier}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Identifier:
                      </Typography>
                      <Typography>{peppolParticipant.identifier}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Endpoint ID:
                      </Typography>
                      <Typography>{peppolParticipant.endpoint_id}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )
      )}
    </>
  );
}
